<template>
  <el-dialog :title="title" :visible.sync="visible" append-to-body :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="文章" prop="content_id">
        <el-select v-model="formData.content_id" placeholder="请选择文章" filterable :filter-method="getContentList" clearable @clear="getContentList">
          <el-option label="选择文章" :value="0"></el-option>
          <el-option v-for="item in contentList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'classical_content_add',
  props: [
    'visible', 'id', 'classical_id'
  ],
  data () {
    return {
      title: '添加经典栏目文章',
      contentList: [],
      formData: {
        classical_id: 0,
        content_id: 0
      },
      addFormRules: {
        content_id: [
          { required: true, message: '文章不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.formData = {
        classical_id: 0,
        content_id: 0
      }
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      this.formData.classical_id = this.classical_id
      this.getContentList('')
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑经典栏目文章'
        this.getInfo(this.id)
      } else {
        this.title = '添加经典栏目文章'
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/classical_content/info/' + id)
      if (res.code === 0) {
        this.formData.content_id = res.data.content_id
        this.getContentList('')
      }
    },
    async getContentList (value) {
      const res = await this.$http.get('/admin/content/select_list', { keyword: value, id: this.formData.content_id })
      if (res.code === 0) {
        this.contentList = res.data
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
